export default "__VITE_ASSET__VC0haXJ4__"